import React from 'react';
import PropTypes from 'prop-types';

import { setClassNames } from '@ddc/classnames-js';

const WhyBuyList = ({ items }) => {
	if (!items || items.length === 0) {
		return <div />;
	}

	const listClassNames = setClassNames(['list-unstyled', 'mb-0']);
	const itemClassNames = setClassNames([
		'd-flex',
		'align-items-center',
		'pb-2'
	]);
	const iconClassNames = [
		'ddc-icon',
		'ddc-icon-size-xlarge',
		'pr-3',
		'line-height-reset'
	];

	return (
		<ul className={listClassNames}>
			{items.map((item) => (
				<li key={item.title} className={itemClassNames}>
					<i
						className={setClassNames([
							...iconClassNames,
							`ddc-icon-${item.iconId}`
						])}
					/>
					<span className="ddc-font-size-small">{item.title}</span>
				</li>
			))}
		</ul>
	);
};
WhyBuyList.propTypes = {
	items: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

export default WhyBuyList;
